import { reduxActionTypePrefix } from "../../../constants/module.constants.js";
const prefix = `${reduxActionTypePrefix}/LIST`;
export {
  prefix
};
//# sourceMappingURL=constants.js.map
